export default "__VITE_ASSET__BpD22eTM__"